import {
  REFRESH_SESSION_TOKEN_SUCCESS,
  RELOAD_SUCCESS,
  SIGNIN_SUCCESS,
} from './currentUser';

import { gatherErrors } from '../utils/errorHandling';
import urls from '../constants/urls';

export const HOSPITAL_LOAD_FAILED = 'hospital/HOSPITAL_LOAD_FAILED';
export const HOSPITAL_LOAD_SUCCESS = 'hospital/HOSPITAL_LOAD_SUCCESS';
export const LOADING_HOSPITAL = 'hospital/LOADING_HOSPITAL';

export const HOSPITAL_UPDATE_FAILED = 'hospital/UPDATE_FAILED';
export const HOSPITAL_UPDATE_SUCCESS = 'hospital/UPDATE_SUCCESS';
export const UPDATING_HOSPITAL = 'hospital/UPDATING';

const initialState = {
  hospital: null,
  adminUsers: [],

  updateErrors: {},

  failedLoading: false,

  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_HOSPITAL:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case HOSPITAL_LOAD_SUCCESS:
      return {
        ...state,
        adminUsers: action.payload.data.admin_users,
        hospital: action.payload.data,
        isLoading: false,
      };

    case HOSPITAL_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    case UPDATING_HOSPITAL:
      return {
        ...state,
        updateErrors: {},
        isUpdating: true,
        failedUpdating: false,
      };

    case HOSPITAL_UPDATE_SUCCESS:
      return {
        ...state,
        updateErrors: {},
        hospital: action.payload.data,
        isUpdating: false,
      };

    case HOSPITAL_UPDATE_FAILED:
      return {
        ...state,
        updateErrors: gatherErrors(action.error, 'update_hospital_failed'),
        isUpdating: false,
        failedUpdating: true,
      };

    case REFRESH_SESSION_TOKEN_SUCCESS:
      return {
        ...state,
        hospital: state.hospital || action.payload.data.hospital,
      };

    case SIGNIN_SUCCESS:
      return {
        ...state,
        hospital: action.payload.data.hospital,
      };

    case RELOAD_SUCCESS:
      return {
        ...state,
        hospital: action.payload.data.hospital,
      };

    default:
      return state;
  }
};

export const loadHospital = id => dispatch => {
  return dispatch({
    types: [LOADING_HOSPITAL, HOSPITAL_LOAD_SUCCESS, HOSPITAL_LOAD_FAILED],
    payload: {
      request: {
        url: urls.hospitals.show(id),
      },
    },
  });
};

export const updateHospital = (id, params) => dispatch => {
  const hospitalParams = {
    name: params.name,
    nickname: params.nickname,
    prefix: params.prefix,
    drop_prefix: params.drop_prefix,
    closed_network_enabled: params.closed_network_enabled,
    hidden: params.hidden,
    // TEMP: Messaging launch changes
    messaging_enabled:
      params.closed_network_enabled && params.messaging_enabled,
    news_feed_enabled: params.news_feed_enabled,
    auto_approve: params.closed_network_enabled && params.auto_approve,
    organisation_id: params.organisation_id,
    favourites_action: params.favourites_action,
    directory_enabled: params.directory_enabled,
    master_key: params.master_key,
    gp_enabled: params.gp_enabled

  };

  return dispatch({
    types: [UPDATING_HOSPITAL, HOSPITAL_UPDATE_SUCCESS, HOSPITAL_UPDATE_FAILED],
    payload: {
      request: {
        method: 'patch',
        url: urls.hospitals.update(id),
        data: { hospital: hospitalParams },
      },
    },
  });
};
